import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

/**
 * Root element for React application
 */
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

/**
 * Service Worker Registration
 * Registers the service worker for PWA functionality
 * Enables offline capabilities and app installation
 */
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Show update notification when a new version is available
    serviceWorkerRegistration.showUpdateNotification(registration);
  },
  onSuccess: (registration) => {
    console.log('Service worker registered successfully!');
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
